import { ThemeEvents } from '@theme/events';

/**
 * Appstle intercepts /cart/add calls to inject the selected selling plan,
 * but forwards back a plain single-item response instead of the
 * `{ sections }` payload our own product-form.js normally requests. That
 * leaves cart:updated firing with no sections, so the drawer renders empty
 * until the next full page load. When that happens, fetch fresh sections
 * ourselves and render them directly.
 */
async function ensureCartDrawerHasFreshContent(event) {
  const sections = event.detail?.data?.sections;
  if (sections && Object.keys(sections).length > 0) return;

  const cartDrawer = document.querySelector('cart-drawer');
  if (!cartDrawer) return;

  const sectionId = cartDrawer.dataset.sectionId;
  if (!sectionId) return;

  const [cart, freshSections] = await Promise.all([
    fetch('/cart.js').then((response) => response.json()),
    fetch(`/?sections=${encodeURIComponent([sectionId, 'auto-gifts'].join(','))}`).then((response) => response.json()),
  ]);

  cartDrawer.renderCartContents({ sections: freshSections, itemCount: cart.item_count });
}

document.addEventListener(ThemeEvents.cartUpdated, ensureCartDrawerHasFreshContent);
